var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[(_vm.user.rol == 'Charity')?_c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('overview-charity')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }